import React from 'react'
import Header from '../components/header/Header';
import Sidebar from '../components/sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import Footer from '../components/footer/Footer';
import { useSelector } from 'react-redux';
import Loader from '../components/common/Loader';
import { selectGlobalLoading } from '../store/selectors/loadingSelector';

const DashboardLayout = () => {
    const isLoading = useSelector(selectGlobalLoading)

    return (
        <>
            {isLoading && <Loader />}

            <div id="wrapper">
                <Header />
                <Sidebar />
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <Outlet />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default DashboardLayout;